'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { BodyShort, Button, CopyButton, Heading, HStack, Link, Select, Tag } from '@navikt/ds-react';
import styles from './UnderenhetKortliste.module.css';
import { store } from '@/app/_components/store/store';
import { AltinnOrganisasjon } from '@/types/api';
import { formatOrgnr } from '@/utils/formatting/tall';
type Sortering = 'navn' | 'arbeidsforhold';
const SIDESTOERRELSE = 15;
const sorter = (underenheter: AltinnOrganisasjon[], sortering: Sortering) => {
  const sortert = [...underenheter];
  switch (sortering) {
    case 'navn':
      return sortert.sort((a, b) => a.navn.localeCompare(b.navn, 'nb'));
    case 'arbeidsforhold':
      return sortert.sort((a, b) => b.antallAktiveArbeidsforhold - a.antallAktiveArbeidsforhold);
  }
};
export default function UnderenhetKortliste(t0) {
  const $ = _c(38);
  const {
    underenheter,
    onVelgUnderenhet
  } = t0;
  const {
    tekst
  } = store.useReducerState();
  const [sortering, setSortering] = React.useState("arbeidsforhold");
  const [antallSynlige, setAntallSynlige] = React.useState(SIDESTOERRELSE);
  let sortert;
  let t1;
  let t2;
  let t3;
  if ($[0] !== antallSynlige || $[1] !== onVelgUnderenhet || $[2] !== sortering || $[3] !== tekst.arbeidsgiverHovedenhet.sorterArbeidsforhold || $[4] !== tekst.filter.sorterEtter || $[5] !== tekst.filter.sorterNavn || $[6] !== tekst.term || $[7] !== tekst.underenhetTableRow || $[8] !== underenheter) {
    sortert = sorter(underenheter, sortering);
    const synlige = sortert.slice(0, antallSynlige);
    let t4;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = e => setSortering(e.target.value as Sortering);
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    let t5;
    if ($[14] !== tekst.arbeidsgiverHovedenhet.sorterArbeidsforhold) {
      t5 = <option value="arbeidsforhold">{tekst.arbeidsgiverHovedenhet.sorterArbeidsforhold}</option>;
      $[14] = tekst.arbeidsgiverHovedenhet.sorterArbeidsforhold;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    let t6;
    if ($[16] !== tekst.filter.sorterNavn) {
      t6 = <option value="navn">{tekst.filter.sorterNavn}</option>;
      $[16] = tekst.filter.sorterNavn;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    if ($[18] !== sortering || $[19] !== t5 || $[20] !== t6 || $[21] !== tekst.filter.sorterEtter) {
      t3 = <Select className={styles.sortering} label={tekst.filter.sorterEtter} size="small" value={sortering} onChange={t4}>{t5}{t6}</Select>;
      $[18] = sortering;
      $[19] = t5;
      $[20] = t6;
      $[21] = tekst.filter.sorterEtter;
      $[22] = t3;
    } else {
      t3 = $[22];
    }
    t1 = styles.liste;
    let t7;
    if ($[23] !== onVelgUnderenhet || $[24] !== tekst.term || $[25] !== tekst.underenhetTableRow) {
      t7 = underenhet => <li key={underenhet.orgnr} className={styles.kort}><Heading level="3" size="xsmall"><Link as="button" type="button" className={styles.lenke} onClick={() => onVelgUnderenhet(underenhet.orgnr)}>{underenhet.navn}</Link></Heading><dl className={styles.detaljer}><BodyShort as="dt" size="small">{tekst.term.organisasjonsnummer}</BodyShort><BodyShort as="dd" size="small"><HStack gap="space-4" align="center">{formatOrgnr(underenhet.orgnr)}<span className={styles.kopier}><CopyButton data-color="accent" size="xsmall" copyText={underenhet.orgnr} aria-label={`${tekst.underenhetTableRow.copyIdent}${underenhet.navn}`} /></span></HStack></BodyShort></dl>{underenhet.antallAktiveArbeidsforhold ? <Tag size="small" data-color="success" className={styles.merkelapp}>{`${underenhet.antallAktiveArbeidsforhold} ${tekst.underenhetTableRow.aktiveArbForhold}`}</Tag> : underenhet.antallInaktiveArbeidsforhold ? <Tag size="small" className={styles.merkelapp}>{`${underenhet.antallInaktiveArbeidsforhold} ${tekst.underenhetTableRow.inaktiveArbForhold}`}</Tag> : null}</li>;
      $[23] = onVelgUnderenhet;
      $[24] = tekst.term;
      $[25] = tekst.underenhetTableRow;
      $[26] = t7;
    } else {
      t7 = $[26];
    }
    t2 = synlige.map(t7);
    $[0] = antallSynlige;
    $[1] = onVelgUnderenhet;
    $[2] = sortering;
    $[3] = tekst.arbeidsgiverHovedenhet.sorterArbeidsforhold;
    $[4] = tekst.filter.sorterEtter;
    $[5] = tekst.filter.sorterNavn;
    $[6] = tekst.term;
    $[7] = tekst.underenhetTableRow;
    $[8] = underenheter;
    $[9] = sortert;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    sortert = $[9];
    t1 = $[10];
    t2 = $[11];
    t3 = $[12];
  }
  let t4;
  if ($[27] !== t1 || $[28] !== t2) {
    t4 = <ul className={t1}>{t2}</ul>;
    $[27] = t1;
    $[28] = t2;
    $[29] = t4;
  } else {
    t4 = $[29];
  }
  let t5;
  if ($[30] !== antallSynlige || $[31] !== sortert.length || $[32] !== tekst.arbeidsgiverHovedenhet.visFlere) {
    t5 = antallSynlige < sortert.length && <Button className={styles.visFlere} variant="secondary" size="small" onClick={() => setAntallSynlige(_temp)}>{tekst.arbeidsgiverHovedenhet.visFlere}</Button>;
    $[30] = antallSynlige;
    $[31] = sortert.length;
    $[32] = tekst.arbeidsgiverHovedenhet.visFlere;
    $[33] = t5;
  } else {
    t5 = $[33];
  }
  let t6;
  if ($[34] !== t3 || $[35] !== t4 || $[36] !== t5) {
    t6 = <div>{t3}{t4}{t5}</div>;
    $[34] = t3;
    $[35] = t4;
    $[36] = t5;
    $[37] = t6;
  } else {
    t6 = $[37];
  }
  return t6;
}
function _temp(antall) {
  return antall + SIDESTOERRELSE;
}